import type { KycSession } from '@/models/KycSession';
import { wellKnownRoutes } from '../routes/wellknown';
import type { RouteLocationRaw } from 'vue-router';

export function redirectToTimeoutWithSessionId({
  kycSession,
  replace,
}: {
  kycSession?: KycSession;
  replace?: boolean;
}): RouteLocationRaw {
  const sessionId = kycSession?.id;
  return {
    name: wellKnownRoutes.Timeout,
    query: { correlationId: sessionId },
    ...(replace ? { replace } : {}),
  };
}
